import React, { useEffect } from "react";
import Modal from "../modal";
import styles from "./Message.module.css";

const Message = ({
  isOpen,
  onClose,
  title,
  description,
  confirmType = "confirm",
  onConfirm,
  confirmMessage,
  onCancel,
  loading = false,
}) => {
  const hasCustomConfirm = confirmMessage !== undefined && confirmMessage !== null;
  const confirmLabel = hasCustomConfirm
    ? confirmMessage
    : confirmType === "delete"
    ? "Delete"
    : confirmType === "inform"
    ? "OK"
    : "Confirm";

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Check if the pressed key is 'Enter' AND the modal is open
      if (event.key === "Enter" && isOpen) {
        event.preventDefault(); // Prevent default form submission if inside a form
        if (!loading && onConfirm) {
           onConfirm();
        }
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, loading, onConfirm]);   

  return (
    <Modal open={isOpen} setOpen={onClose}>
      <div className={styles.messageContainer}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>

        <div className={styles.buttonContainer}>
          <button
            type="button"
            onClick={onCancel || onClose}
            className={styles.cancelButton}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={
              confirmType === "delete"
                ? styles.deleteButton
                : styles.confirmButton
            }
          >
            {loading ? "Processing" : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default Message;